import React,{ useState, useEffect, useRef, useCallback } from 'react'
import { Select, message } from 'antd'
import axios from '@/axios'
import moment from 'moment'
import cookie from 'react-cookies'
import { useLocation } from 'react-router-dom'
import store from '@/redux'
import * as types from '@/redux/types.js'

const Option = Select.Option

export default {
  /**
   * 获取按钮权限数据（后台返回）
   **/
  getButtonData() {
    return localStorage.getItem('buttonData')
      ? JSON.parse(localStorage.getItem('buttonData') || [])
      : []
  },

  /**
   * 按钮是否有权限
   **/
  isPermit(pcode,code) {
    if(!code){
      return true
    }
    let arr = []
    const buttonData = this.getButtonData()
    buttonData.forEach(item => {
      if (item.code == pcode) {
        arr = item.children
      }
    })
    let isOk=false
    arr.forEach(item => {    // 校验是否显示
      const mcodeArr = item.code.split(':')
      const mcode = mcodeArr[mcodeArr.length - 1]
      if (mcode == code) {
        isOk=true
        return
      }
    })
    return isOk
  },
    /**
   * 页面是否有权限显示
   **/
    isPermitPage(pcode) {
      if(!pcode){
        return true
      }
      let isOk=false
      const buttonData = this.getButtonData()
      buttonData.forEach(item => {
        if (item.code == pcode) {
          isOk=true
        }
      })
      return isOk
    },
  
  /**
   * 获取iframe url前缀，type目前有：
   * 1、wf，即流程页面，
   * 2、g7，即g7 thymeleaf页面
   **/
  getUrlPrefix(type) {
    let urlPrefix = localStorage.getItem('urlPrefix')
    urlPrefix = JSON.parse(urlPrefix)
    urlPrefix = urlPrefix[type]
    return urlPrefix
  },

  /**获取当前时间和当前时间的前 n 天时间 (默认7天) */
  getDate(n = 7) {
    let date = []
    const leadTime = n ?? 7
    const endTime = moment().format('YYYY-MM-DD') + ' 23:59:59' //当前时间
    const startTime = moment().subtract(leadTime, 'days').format('YYYY-MM-DD') + ' 00:00:00' //当前时间的前n天时间
    date.push(startTime, endTime)
    return date
  },

  /**获取当前时间的前n天和当前时间的后 n 天时间 (默认1天) */
  getDatePeriod(n = 1) {
    let date = []
    const leadTime = n ?? 1
    const startTime = moment().subtract(leadTime, 'days').format('YYYY-MM-DD') + ' 00:00:00' //当前时间
    const endTime = moment().add(leadTime, 'days').format('YYYY-MM-DD') + ' 23:59:59' //当前时间的前n天时间
    date.push(startTime, endTime)
    return date
  },

  // 渲染select组件下拉数据id
  getOptionList(data) {
    if (!data) {
      return []
    }
    let newData = [...data]
    return newData.map((item, i) => {
      const code = item.selectCode ? item.selectCode.toString() : undefined
      return (
        <Option value={code} key={i}>
          {item.selectName}
        </Option>
      )
    })
  },
  // 自定义icon
  // myIcon() {
  //   const MyIcon = createFromIconfontCN({
  //     scriptUrl: '//at.alicdn.com/t/font_2193100_y389dxywuq.js', // 在 iconfont.cn 上生成
  //   });
  //   return MyIcon
  // },
  // 树型控件方法，获取父节点
  getParentKey(key, tree) {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key
        } else if (this.getParentKey(key, node.children)) {
          parentKey = this.getParentKey(key, node.children)
        }
      }
    }
    return parentKey
  },
  /**
   * 解决两个数相加精度丢失问题
   * @param a
   * @param b
   * @returns {Number}
   */
  floatAdd(a, b) {
    var c, d, e
    if (undefined == a || null == a || '' == a || isNaN(a)) {
      a = 0
    }
    if (undefined == b || null == b || '' == b || isNaN(b)) {
      b = 0
    }
    try {
      c = a.toString().split('.')[1].length
    } catch (f) {
      c = 0
    }
    try {
      d = b.toString().split('.')[1].length
    } catch (f) {
      d = 0
    }
    e = Math.pow(10, Math.max(c, d))
    return (this.floatMul(a, e) + this.floatMul(b, e)) / e
  },
  /**
   * 解决两个数相减精度丢失问题
   * @param a
   * @param b
   * @returns {Number}
   */
  floatSub(a, b) {
    var c, d, e
    if (undefined == a || null == a || '' == a || isNaN(a)) {
      a = 0
    }
    if (undefined == b || null == b || '' == b || isNaN(b)) {
      b = 0
    }
    try {
      c = a.toString().split('.')[1].length
    } catch (f) {
      c = 0
    }
    try {
      d = b.toString().split('.')[1].length
    } catch (f) {
      d = 0
    }
    e = Math.pow(10, Math.max(c, d))
    return (this.floatMul(a, e) - this.floatMul(b, e)) / e
  },
  /**
   * 解决两个数相乘精度丢失问题
   * @param a
   * @param b
   * @returns {Number}
   */
  floatMul(a, b) {
    var c = 0,
      d = a.toString(),
      e = b.toString()
    try {
      c += d.split('.')[1].length
    } catch (f) {}
    try {
      c += e.split('.')[1].length
    } catch (f) {}
    return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
  },
  /**
   * 解决两个数相除精度丢失问题
   * @param a
   * @param b
   * @returns
   */
  floatDiv(a, b) {
    var c,
      d,
      e = 0,
      f = 0
    try {
      e = a.toString().split('.')[1].length
    } catch (g) {}
    try {
      f = b.toString().split('.')[1].length
    } catch (g) {}
    console.log('this.', this)
    return (
      (c = Number(a.toString().replace('.', ''))),
      (d = Number(b.toString().replace('.', ''))),
      this.floatMul(c / d, Math.pow(10, f - e))
    )
  },
  /**
   * 时间戳转时间
   */
  getTime(nS) {
    const date = new Date(nS)
    const year = date.getFullYear()
    const mon = date.getMonth() + 1
    const m = mon >= 10 ? mon : '0' + mon
    const day = date.getDate()
    const d = day >= 10 ? day : '0' + day
    const hours = date.getHours()
    const h = hours >= 10 ? hours : '0' + hours
    const minu = date.getMinutes()
    const mi = minu >= 10 ? minu : '0' + minu
    const sec = date.getSeconds()
    const s = sec >= 10 ? sec : '0' + sec

    return year + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s
  },
  /**
   * 导出文件
   */
  exportFile(bizType, params = {}) {
    axios.ajax(`export/${bizType}/excel`, 'GET', params, 180000).then((res) => {
      if (res.success) {
        if (res.errCode == 200) {
          // axios.ajax('fileManage/getById', 'GET', { id: res.data }).then(resl => {
          //   if (resl.success) {
          //     window.location.href = resl.data.url
          //   }
          // })
          window.location.href = res.data
        } else if (res.errCode == 100) {
          message.info(res.data)
        }
      }
    })
  },

  getCookie(name, defaultValue) {
    const v = cookie.load(name)
    return v ? v : defaultValue
  },

  /**
   * 保存token到cookie
   **/
  saveToken(token) {
    if (token) {
      localStorage.setItem('accessToken', token)
      // cookie.save('token', token, { expires: 0, path: "/" });
    }
  },

  /**
   * 获取当前保存的token
   **/
  getToken() {
    return localStorage.getItem('accessToken')
    // return cookie.load('token');
  },

  /**
   * 移除token
   **/
  removeToken() {
    // cookie.remove('token');
    localStorage.removeItem('accessToken', null)
  },
  /**
   * 保存isLogin到cookie
   **/
  saveIsLogin() {
    // cookie.save('isLogin', 1, { expires: 0 });
    return localStorage.setItem('isLogin', 1)
  },

  /**
   * 获取当前保存的isLogin
   **/
  isLogin() {
    // return cookie.load('isLogin');
    return localStorage.getItem('isLogin')
  },

  /**
   * 移除isLogin
   **/
  removeIsLogin() {
    // cookie.remove('isLogin');
    localStorage.removeItem('isLogin', '0')
  },

  /* 退出登录，清空用户相关信息 */
  cleanUserInfo() {
    this.removeToken()
    this.removeIsLogin()
    localStorage.removeItem('cardDateType','')//清空一人一岗的日期选择
    localStorage.removeItem('loginName')   // 清空登陆名
    store.dispatch({ // 清空tabs数据
      type: types.DEL_TABSLIST,
      payload: {list: [{name: '首页', route: '/home', active: true, isRight: false}]}
    })
    store.dispatch({    // 清空菜单配置权限
      type: types.CLEAR_MENU_LIMITS,
      payload: {}
    })
    store.dispatch({    // 清空按钮配置权限
      type: types.CLEAR_BUTTON_LIMITS,
      payload: {}
    })
    store.dispatch({ // 清空角色类型
      type: types.UPDATE_USER_INFO,
      payload: {
        obj: {}
      }
    })
    store.dispatch({ // 清空我的工作台
      type: types.WORKBENCH_INFO,
      payload: {
        obj: {}
      }
    })
  },

  /**
   * 是否开启安全模式
   **/
  ifEnableSecure() {
    const enableSecure = localStorage.getItem('enableSecure')
    return enableSecure && enableSecure == '1'
  },

  /* 
    保存用户二级验证信息
    使用数组对象保留，防止用户切换账号后不出现二级验证
    存储格式： {account: value, expire: expire}
    account: 用户账号
    expire：过期时间
  */
  setCertificate(account, expire) {
    const expireTime = moment().add(expire, 'd')
    const obj = {account, expire: expireTime}
    const certificateList = JSON.parse(localStorage.getItem('certificate')) || []
    const delItem = certificateList.findIndex(item => item.account == account)
    delItem === -1 ? certificateList.push(obj) : certificateList.splice(delItem, 1, obj)
    localStorage.setItem('certificate', JSON.stringify(certificateList))
  },

  /* 
    获取当前二级加密是否过期
    account: 用户账号
  */
  isCertificate(account) {
    const shouldCertificate = false // 是否进行验证,为false直接跳过
    if (!shouldCertificate) return false
    const certificateList = JSON.parse(localStorage.getItem('certificate')) || []
    if (certificateList.length <= 0) return true // 已认证的账号为空
    const isInList = certificateList.findIndex(item => item.account == account)
    if (isInList == -1) return true // 未找到当前账号 
    const obj = certificateList[isInList]
    if (moment().isBefore(moment(obj.expire))) { // 比较两个时间
      return false
    } else {
      return true
    }
  },

  /**
   * 数组对象去重
   * arr 去重数组
   * str 按给定字段去重
   **/
  arrayObjRepeat(arr, str) {
    let map = new Map()
    for (let item of arr) {
      if (!map.has(item[str])) {
        map.set(item[str], item)
      }
    }
    return [...map.values()]
  },

  /**
   * 如果有指定判断对象，删除时间字段
   * @param {表单提交参数} data
   * @param {指定判断对象} orderNumber
   * @param {清空开始时间字段} startTime
   * @param {清空结束时间字段} entTime
   */
  isOrderNumberFn(data, orderNumber, startTime, entTime) {
    //设置默认值
    data.pageSize=data.pageSize?data.pageSize:20;
    // 单号存在去掉时间字段
    if (orderNumber) {
      return {
        ...data,
        [startTime]: undefined,
        [entTime]: undefined,
      }
    }
    return data
  },

  /**
   * 表格列排序
   * @param {指定排线字段} propeties
   * @param {是否数字排序} isNumber
   */
  compareSortFunction(propeties, isNumber) {
    // 中文和字母排序
    const compareSort = (a, b) => {
      if (!a[propeties]) {
        a[propeties] = ''
      }
      if (!b[propeties]) {
        b[propeties] = ''
      }
      if (typeof a[propeties] !== 'number') {
        return a[propeties].localeCompare(b[propeties])
      }
    }
    // 数字排序
    const compareSort1 = (a, b) => a[propeties] - b[propeties]
    return isNumber ? compareSort1 : compareSort
  },

  /* 下载文件 */
  downloadFile(data, fileName, fileType) {
    const blob = new Blob([data], { type: fileType })
    const aLink = document.createElement('a')
    aLink.style.display = 'none'
    aLink.href = window.URL.createObjectURL(blob)
    aLink.download = fileName + '.' + fileType
    document.body.appendChild(aLink)
    aLink.click()
    document.body.removeChild(aLink)
  },

  // 手机号加密
  encryptPhone(phone) {
    if (!phone) return false
    return phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2')
  },

  // 获取浏览器宽高
  useWindowSize() {
    const getWindowSize=()=>({
      height: window.innerHeight,
      width: window.innerWidth,
    })
    const [windowSize, setWindowSize] = useState(getWindowSize())
    const handleResize=()=>{
      setWindowSize(getWindowSize())
    }
    useEffect(()=>{
      window.addEventListener('resize', handleResize)
      return ()=>window.removeEventListener('resize',handleResize)
    },[])
    return windowSize
  },

  /**
  * 自定义hooks用于获取路由参数
  * IE11及以下浏览器 不支持浏览器内置的URLSearchParams API
  **/
  useQuery(search) {
    if (!search) return
    const query = new URLSearchParams(useLocation().search)
    return query.get(search)
  },

  /**
  * 防抖
  * fn：防抖方法
  * delay: 延迟时间
  **/
  debounce(fn, delay=1000) {
    const { current } = useRef({ fn, timer: null });
    useEffect(function () {
      current.fn = fn;
    }, [fn]);
  
    return useCallback(function f(...args) {
      if (current.timer) {
        clearTimeout(current.timer);
      }
      current.timer = setTimeout(() => {
        current.fn.call(this, ...args);
      }, delay);
    })
  },
  //生成UUID
  generateUUID() {
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    return s.join('');
  },

  /**
   * 节流
   * fn: 节流方法
   * delay: 延迟时间
   * dep: 依赖
  **/
   useThrottle(fn, delay=1000, dep=[]) {
    const { current } = useRef({ fn, timer: null });
    useEffect(function () {
      current.fn = fn;
    }, [fn]);
  
    return useCallback(function f(...args) {
      if (!current.timer) {
        current.timer = setTimeout(() => {
          delete current.timer;
        }, delay);
        current.fn(...args);
      }
    }, dep)
   },

   /**  
    * 判断数组或对象是否为空
    * obj Object or Array
   **/
  isObjectOrArrayEmpty: function(obj) {
    if (obj instanceof Object && Object.keys(obj).length!=0) return false
    else return true
  },

  /**
   * 根据url下载文件
   * URL
  */
  downloadFileWithUrl: function (url) {
    const eleLink = document.createElement('a')
    eleLink.style.display = 'none'
    eleLink.target = "_blank"
    eleLink.href = url
    document.body.appendChild(eleLink)
    eleLink.click()
    document.body.removeChild(eleLink)
  },

  /**
   * 搜索时地址框获取值
   * areaId: 地址值 Array|String
   */
  getAreaId: function (areaId) {
    if (!areaId) {
      return ''
    } else if (areaId instanceof Array) { // 如果是数组
      return areaId[areaId.length - 1] ? areaId[areaId.length - 1] : ''
    } else { // 如果是字符串
      return areaId
    }
  },

  /**
   * 对象转化FormData格式
   * 如A=1&B=2
   */
  urlencodeFormData: function (fd) {
    var s = []

    for (var key in fd) {
      if (fd.hasOwnProperty(key)) {
        let val = fd[key]
        if (
          val &&
          typeof val == 'string' &&
          ((val.indexOf('{') == 0 && val.lastIndexOf('}') == val.length - 1) ||
            (val.indexOf('[') == 0 && val.lastIndexOf(']') == val.length - 1))
        )
          //如果key、value中的value是字符串类型，且是json对象或数组序列化为字符串的，就不要再encode了，否则会报错
          s.push(encodeURIComponent(key) + '=' + fd[key])
        else s.push(encodeURIComponent(key) + '=' + encodeURIComponent(fd[key]))
      }
    }

    return s.join('&')
  },

  /**
   * 金额类，数据右对齐  ，显式样式  888,8888,888.88
   * 如12,345,678,901,234.88888(12,345,678,901,234.889)---超过带有2位小数的14位整数的或没有小数的16位整数显示不正常，电脑自动处理最后一位会四舍五入，因为电脑处理数据有限的
   */
    getMoneyValue: function (value,precision=2) {
      // 将非数字字符替换为空字符串
      let mvalue = `${value}`.replace(/[^\d.-]/g, '');
      if(mvalue===''){
        return ''
      }
      // 分离整数部分和小数部分
      let [integerPart, decimalPart = ''] = mvalue.split('.');
      // 将整数部分每3位用逗号隔开
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 如果小数部分不足precision位，则自动补零
      if (decimalPart.length < precision) {
        decimalPart = decimalPart.padEnd(precision, '0');
      }
      // 限制小数部分的位数
      decimalPart = decimalPart.slice(0, precision);
      // 如果小数部分不为空，则加上小数点
      if (decimalPart) {
        decimalPart = `.${decimalPart}`;
      }
      // 返回格式化后的字符串
      return `${integerPart}${decimalPart}`;
    },

   /**
   * 主要用于格式化金额的input输入的组件，使其数据右对齐，显式样式  888,8888,888.88
   */
    formatMoney: function () {
      return {
        formatter: function(value) {
          let mvalue = `${value}`.replace(/[^\d.-]/g, '');
          // 分离整数部分和小数部分
          let [integerPart, decimalPart = ''] = `${mvalue}`.split('.');
          // 将整数部分每3位用逗号隔开
          integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          // 如果小数部分不足precision位，则自动补零
          // if (decimalPart.length < precision) {
          //   decimalPart = decimalPart.padEnd(precision, '0');
          // }
          // 限制小数部分的位数
          // decimalPart = decimalPart.slice(0, 3);
          // 如果小数部分不为空，则加上小数点
          if (decimalPart) {
            decimalPart = `.${decimalPart}`;
          }
          // 返回格式化后的字符串
          return `${integerPart}${decimalPart}`;
          // return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
        parser: function(value) {//parser={value => value.replace(/\$\s?|(,*)/g, '')}
          return value.replace(/(,*)/g, '')
        }
      }
       
    },
    //阿拉伯数字转中文大写
    numberToChinese:function (num)  {
      var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十");
      var BB = new Array("", "十", "百", "仟", "萬", "億", "点", "");
      var a = ("" + num).replace(/(^0*)/g, "").split("."),
        k = 0,
        re = "";
      for (var i = a[0].length - 1; i >= 0; i--) {
        switch (k) {
          case 0:
            re = BB[7] + re;
            break;
          case 4:
            if (!new RegExp("0{4}//d{" + (a[0].length - i - 1) + "}$")
              .test(a[0]))
              re = BB[4] + re;
            break;
          case 8:
            re = BB[5] + re;
            BB[7] = BB[5];
            k = 0;
            break;
        }
        if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0)
          re = AA[0] + re;
        if (a[0].charAt(i) != 0)
          re = AA[a[0].charAt(i)] + BB[k % 4] + re;
        k++;
      }
     
      if (a.length > 1) // 处理小数
      {
        re += BB[6];
        for (var i = 0; i < a[1].length; i++)
          re += AA[a[1].charAt(i)];
      }
      if (re == '一十')
        re = "十";
      if (re.match(/^一/) && re.length == 3)
        re = re.replace("一", "");
      return re;
    },
    numberToWord:function (num) {
      if(typeof num !== 'number'){
        return num
      }
      return String.fromCharCode(64 + num)
    },

    // 字符串是否数字
    isNumber(str) {
      return !isNaN(parseFloat(str)) && isFinite(str)
    },
    

}
